/* eslint-disable no-unused-vars */
import React, { useState, useContext } from "react";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
// import { AuthContext } from "../context/AuthContext";
import { login as authLogin } from '../services/authService';


const LoginModal = ({ show, onHide }) => {
    // const { login } = useContext(AuthContext);
    const navigate = useNavigate();
    const [credentials, setCredentials] = useState({
        userPhone: '',
        userPassword: ''
    });
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    // Special handler for phone input
    const handlePhoneChange = (phoneValue) => {
        setCredentials({
            ...credentials,
            userPhone: phoneValue
        });
    };

    const handleChange = (e) => {
        setCredentials({
            ...credentials,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);

        try {
            const response = await authLogin(credentials);
            console.log('LOGIN RESPONSE:', response);

            if (response.success) {
                navigate('/eotp', {
                    state: {
                        userPhone: credentials.userPhone,
                        userPassword: credentials.userPassword,
                        userEmail: response.data.userEmail
                    }
                });
                onHide(); // Just close the modal, don't redirect
            }
        } catch (err) {
            setError(err.message || 'Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEmailLogin = () => {
        onHide();
        navigate('/email-otp');
    };

    return (
        <>
            <Modal show={show} onHide={onHide} centered className="fade" id="login_modal">
                <Modal.Body className="p-4">
                    <div className="login-header text-center mb-4">
                        <h3>Login <span>Howzit!</span></h3>
                    </div>

                    {error && (
                        <div className="alert alert-danger mb-4">
                            <div className="d-flex align-items-center">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                <div>
                                    <strong>Login Error!</strong>
                                    <div className="small">{error}</div>
                                    {error.includes('celebrity') && (
                                        <Link to="/celebrity-login" className="alert-link">
                                            Go to Celebrity Login →
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Phone Number</label>
                            <div className="phone-control custom-phone-input">
                                <PhoneInput
                                    international
                                    defaultCountry="ZW"
                                    countryCallingCodeEditable={false}
                                    name="userPhone"
                                    value={credentials.userPhone}
                                    onChange={handlePhoneChange}
                                    placeholder="Enter phone number"
                                    className="PhoneInput"
                                    inputComponent="input"
                                />
                            </div>
                        </div>

                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <label className="form-label">Password</label>
                                <Link to="/forgot-password" className="forgot-link" onClick={onHide}>
                                    Forgot password?
                                </Link>
                            </div>
                            <div className="pass-group" style={{ position: 'relative' }}>
                                <input
                                    type={isPasswordVisible ? "text" : "password"}
                                    className="form-control pass-input-sub"
                                    name="userPassword"
                                    value={credentials.userPassword}
                                    onChange={handleChange}
                                    required
                                />
                                <span
                                    onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        color: '#6c757d',
                                        fontSize: '16px',
                                        zIndex: 10
                                    }}
                                >
                                    {isPasswordVisible ? '🙈' : '👁️'}
                                </span>
                            </div>
                        </div>
                        <div className="mb-3">
                            <button className="btn btn-primary-gradient w-100" type="submit" disabled={isLoading}>
                                {isLoading ? 'Sending OTP...' : 'Send OTP'}
                            </button>
                        </div>

                        <div className="login-or position-relative my-4">
                            <span className="or-line" />
                            <span className="span-or bg-white px-2">or</span>
                        </div>

                        <div className="mb-3 text-center">
                            <button
                                type="button"
                                className="btn btn-outline-primary w-100"
                                onClick={handleEmailLogin}
                            >
                                Sign in with Email
                            </button>
                        </div>

                        <div className="text-center mt-3">
                            <p className="mb-0">
                                Are you a celebrity?{' '}
                                <Link to="/celebrity-login" className="text-primary">
                                    Click here to access your dashboard
                                </Link>
                            </p>
                        </div>

                        <div className="account-signup text-center mt-3">
                            <p className="mb-0">
                                Don't have an account?{" "}
                                <Link to="/register" onClick={onHide}>Sign up</Link>
                            </p>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default LoginModal;
